import { produce } from 'immer';
import React, { memo, useCallback } from 'react';
import { updateDashboardFunc } from '../../../../../lib/helper';
import { Dashboard } from '../../../../../types/files';
import StageSelector from '../../../../molecules/crunchbase-modal/StageSelector';

const StageCell: React.FC<{ dashboard: Dashboard }> = ({ dashboard }) => {
    const handleSelectStage = useCallback(async (value: string) => {
        if (dashboard.investmentStage !== value) {
            await updateDashboardFunc(produce(dashboard, (draft) => {
                draft.investmentStage = value;
            }));
        }
    }, [dashboard]);

    return (<>
        <StageSelector
            defaultStage={dashboard?.investmentStage ?? undefined}
            onSelectStage={handleSelectStage}
            filled={!!dashboard?.investmentStage} />
    </>);
}

export default memo(StageCell);
